enum OrderStatus {
  Unfulfilled = 'unfulfilled',
  Unpaid = 'unpaid',
  Closed = 'closed',
  All = 'all',
  New = 'new',
}

export default OrderStatus;
